import { RadioButton } from 'primereact/radiobutton';
import '../App.css';
import AdCreative from '../AdCreative';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';

function CampaignNewStepUpload({
    setStep,
    creativeURL,
    setCreativeURL,
    creativeExt,
    setCreativeExt,
    setPreviewMediaFileUUID,
    previewURL,
    setPreviewURL,
    preview_ext,
    setPreviewExt,
}) {
    return (
        <div>
            <div className='mk2-title'>
                Image or video
            </div>
            <div>
                {
                    !creativeURL &&
                    <div className="flex flex-wrap gap-3">
                        <div className="flex align-items-center" style={{ margin: '0.4em' }}>
                            <label htmlFor="ingredient2" className="ml-2" style={{ marginLeft: '0.2em' }}>
                            </label>
                        </div>
                    </div>
                }
                <div>
                    {
                        creativeURL &&
                        <AdCreative
                            creativeURL={creativeURL}
                            creativeExt={creativeExt}
                            // width='100%'
                        />
                    }
                    {
                        !creativeURL &&
                        <div>
                            <FileUpload
                                auto={true}
                                name="files"
                                url={process.env.REACT_APP_API_HOST + '/file/upload/'}
                                multiple
                                accept="image/*,video/*"
                                maxFileSize={900000000}
                                emptyTemplate={
                                    <p className="m-0">Drag and drop files to here to upload.</p>
                                }
                                onUpload={
                                    (response) => {
                                        const data = JSON.parse(response.xhr.response);
                                        setCreativeURL(data.url);
                                        setCreativeExt(data.ext);
                                        setPreviewURL(data.preview_url);
                                        setPreviewExt(data.preview_ext);
                                        setPreviewMediaFileUUID(data.preview_media_file_uuid);
                                    }
                                }
                            />
                        </div>
                    }
                </div>
            </div>
            <div style={{ marginTop: '1em' }}>
                <Button
                    label="Back"
                    severity="secondary"
                    onClick={
                        () => {
                            setCreativeURL(null);
                            setCreativeExt(null);
                            setPreviewURL(null);
                            setPreviewExt(null);
                        }
                    }
                    style={{ marginRight: '0.5em' }}
                    size='small'
                    outlined
                />
                <Button
                    label='Continue'
                    severity='success'
                    size='small'
                    onClick={
                        () => {
                            if (!previewURL) {
                                setStep('set_time_to_display');
                                return;
                            }

                            setStep('preview');
                        }
                    }
                    disabled={!creativeURL}
                    outlined
                />
            </div>
        </div>
    );
}

export default CampaignNewStepUpload;